module.exports = __webpack_public_path__ + "img/efce4c9.png";